// extracted by mini-css-extract-plugin
export var discard = "_2a-4";
export var muiTooltipTooltip = "_2a-6";
export var notificationBar = "_2a-3";
export var notificationContainer = "_2a-2";
export var saveButtonHoverSlotWrapper = "_2a-5";
export var show = "_2a-1";
export var spacer = "_2a-0";